class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/webhooks`;
    }
    /**
     * Returns webhooks which are available for the current user by group ID.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/groups/{groupId}/webhooks
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new webhook.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/groups/{groupId}/webhooks
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
